export default __webpack_public_path__ + "static/media/successMsg.c411fc6c.svg";